import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError, AxiosResponse } from 'axios';
import { storeKey } from '../constants';
import {
  CreateClientReducer,
  CreateClientRequest,
  CreateClientResponse,
} from '../types';
import axiosInstance from '../../../config/axios';
import { EndPoints } from '../../../constants/apiUrls';
import { toast } from 'react-toastify';

const initialState: CreateClientReducer = {
  isCreateClientSuccess: null,
};

const createClientSlice = createSlice({
  name: 'postCreateClient',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(createClient.pending, (state) => {
      state.isCreateClientSuccess = false;
    });
    builder.addCase(createClient.fulfilled, (state) => {
      state.isCreateClientSuccess = true;
      toast.success('Account Created Successfully!');
    });
    builder.addCase(createClient.rejected, (state, action) => {
      state.isCreateClientSuccess = false;
      const errorResponses = (action.payload as AxiosError).response?.data as {
        error: string;
      };
      toast.error(errorResponses.error);
    });
  },
});


export const createClient = createAsyncThunk<
  CreateClientResponse,
  CreateClientRequest
>(
  `${storeKey}/postCreateClient`,
  async (createClientRequest: CreateClientRequest, { rejectWithValue }) => {
    try {
      const response: AxiosResponse<CreateClientResponse> =
        await axiosInstance.post(
          EndPoints.POST_CREATE_CLIENT,
          createClientRequest,
        );
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export default createClientSlice.reducer;
